// v1→v2 cutover redirect for the legacy shop-floor pages.
//
// Once the server flips V1_WO_CREATION_ENABLED off (the cutover), landing on
// a v1 shop-floor URL silently forwards to the v2 equivalent — operation
// codes are shared between the two systems, so `/shop-floor/OP-10` maps to
// `/manufacturing/v2/shop-floor/OP-10`. While the flag is still on (or the
// flag fetch fails) the v1 page renders as normal.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v2 } from '../../services/api';

export default function useV2CutoverRedirect(target) {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    v2.featureFlags.get()
      .then((res) => {
        if (cancelled) return;
        if (res.data?.v1_wo_creation_enabled === false) {
          // replace: the v1 URL never enters history, so Back doesn't bounce.
          navigate(target, { replace: true });
        }
      })
      .catch(() => { /* can't read the flag → stay on v1 */ });
    return () => { cancelled = true; };
  }, [navigate, target]);
}
